<template>
  <div style="display: flex;justify-content: center;align-items: center;padding-top: 100px;">
    <el-form ref="form" :model="form" style="width: 700px;">
      <div>
        <h3>标题</h3>
        <el-form-item prop="first_draft_title" :rules="{ required: true, message: '请输入标题', trigger: 'blur' }">
          <el-input placeholder="请输入标题" v-model="form.first_draft_title" style="width: 400px;" />
        </el-form-item>
        <h3 style="font-weight: 600;" class="description">测评内容</h3>
        <el-form-item prop="first_draft_content" :rules="{ required: true, message: '请输入测评内容', trigger: 'blur' }">
          <!-- <p style="width: 400px;border: 1px solid #ccc;padding: 15px 10px;">
                    只计算得分几热国土局埃弗顿工卡何如哈维只计算得分几热国土局埃弗顿工卡何如哈维只计算得分几热国土局埃弗顿工卡何如哈维
                    </p> -->
          <el-input style="width: 450px;" type="textarea" :rows="4" placeholder="测评内容"
            v-model="form.first_draft_content" />
        </el-form-item>
        <h3 style="font-weight: 600;" class="description">测评视频/图片</h3>
        <el-form-item prop="first_draft_url" :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
          <upload-list :list="form.first_draft_url" width="150px" height="150px"></upload-list>
        </el-form-item>
      </div>
      <div style="padding: 80px 100px 30px 0;display: flex;align-items: center;justify-content: center;">
        <el-button @click="backHandler">返回</el-button>
        <el-button style="margin-left: 100px;" :loading="submitting" @click="onSubmitFirst('form')">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";

export default {
  data: () => ({
    videoType: ['mp4', 'rmvb', 'wmv', 'avi', 'mov', 'flv'],
    form: {
      order_id: null,
      type: 3,
      first_draft_title: '',
      first_draft_content: '',
      first_draft_url: [],
    },
    submitting: false,
  }),
  components: {
    UploadList, Tinymce
  },
  props: {
    id: String | Number,
    title: String,
  },
  methods: {
    backHandler() {
      this.$router.back();
    },
    trunOff() {
      // this.showModal = false;
    },
    onSubmitFirst(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.type = 3;
          try {
            this.submitting = true;

            let first_draft_url = this.form.first_draft_url.map((item) => {
              return {
                path: item,
                type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
              }
            })
            
            await zhongcao.firstDraftSubmit({ ...this.form, first_draft_url });
            this.$message({
              message: "提交初稿成功!",
              type: "success",
            });
            this.backHandler()
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.submitting = false;
          }
        }
      });
    },

  },
  computed: {
    // showModal: {
    //   get() {
    //     return this.show;
    //   },
    //   set(val) {
    //     this.$emit("update:show", val);
    //   },
    // },
  },
  watch: {
    form:{
      handler(val) {
          if (val.first_draft_url.length > 0) {
            this.$refs.form.validateField('first_draft_url');
          }
      },
      deep: true
    }
  },
  created() {
    this.form.order_id = this.id
  },
};
</script>

<style lang="scss" scoped>
.description{
  padding: 0 0 10px 0;
  background: url('~@/assets/tagBottom.png') no-repeat 0 10px;
  background-size: 60px 15px;
}
</style>
